import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface IAcompanharPedidoStore {
    pedido: {
        id: string,
        empresaId: string
    } | undefined;
    getPedido: (empresaId: string) => {
        id: string,
        empresaId: string
    } | undefined;
    novoPedido: (id: string, empresaId: string) => void;
    removerPedido: () => void;
}

export const useAcompanharPedidoStore = create<IAcompanharPedidoStore>()(
    persist(
        (set, get) => ({
            pedido: {
                id: '',
                empresaId: ''
            },
            getPedido: (empresaId: string) => {
                if (get().pedido?.empresaId === empresaId) {
                    return get().pedido;
                }
                return undefined;
            },
            novoPedido: (id: string, empresaId: string) => set({ pedido: { id, empresaId } }),
            removerPedido: () => set({ pedido: undefined }),
        }),
        {
            name: 'acompanhar-pedido-store',
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({ pedido: state.pedido }),
        }
    )
);